// const PRACTICE_NUMBER = '6B-es'

let PRACTICE_NUMBER = '6B-es'
let uri = window.location.search.substring(1)
let params = new URLSearchParams(uri)
const pratice = params.get('pratice')

if (pratice !== null) {


  switch (pratice) {
    case '1':
      PRACTICE_NUMBER = '1'
      break
    case '2':
      PRACTICE_NUMBER = '2'
      break
    case '3':
      PRACTICE_NUMBER = '3'
      break
    case '4':
      PRACTICE_NUMBER = '4'
      break
    case '6A':
      PRACTICE_NUMBER = '6A'
      break
    case '6B':
      PRACTICE_NUMBER = '6B'
      break
    case '6C':
      PRACTICE_NUMBER = '6C'
      break
    case '7':
      PRACTICE_NUMBER = '7'
      break
    case '13':
      PRACTICE_NUMBER = '13'
      break
    case '1_es':
      PRACTICE_NUMBER = '1-es'
      break
    default:
      PRACTICE_NUMBER = '6B-es'
      break
  }
}

export default {
  PRACTICE_NUMBER
}
